import { calculateHeightToBottom } from '@client/utils/dom';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

export const campaignDetails = {
  element: '#campaign-editor > div.page-content > div.campaign-layout > div:nth-child(2)',
  popover: {
    title: 'Campaign Details',
    description: 'This section includes key info about your campaign—name, schedule, tags, categories, and more.',
    side: 'right',
    align: 'center'
  }
};

export const adDetails = {
  element: '.section .tour-ad-setup',
  popover: {
    title: 'Ad Details',
    description: 'This section covers your ad settings—click actions, UTM parameters, ad type, and more.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const parentSelector = '#campaign-editor > div.page-content > div.campaign-layout > div:nth-child(4)';
      const parent = document.querySelector(parentSelector);
      const parentHeight = parent.offsetHeight;

      const element = document.querySelector('.section .tour-ad-setup');
      const heightToBottom = calculateHeightToBottom(element);

      if (parentHeight > heightToBottom) {
        element.style.height = `${heightToBottom}px`;
      } else {
        adDetails.element = parentSelector;
      }
    }
  }
};

export const targetingDetails = {
  element: '#campaign-editor > div.page-content > div.campaign-layout > div:nth-child(6)',
  popover: {
    title: 'Targeting Details',
    description: 'This section includes your ad targeting settings—domain and recipient-based configurations.',
    side: 'right',
    align: 'center',
    onNextClick: () => {
      const insightsSection = document.querySelector(
        '#campaign-editor > div.page-content > div.campaign-layout > h2:nth-child(7)'
      );

      if (insightsSection) {
        insightsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

      setTimeout(() => {
        GLOBAL_DRIVER_OBJECT.moveNext();
      }, 150);
    }
  }
};
